import React, { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { history } from 'nallian-shared-ui/lib/config/history';
import ContactForm from './ContactForm';
import updateOrganisationContactService from '../../services/contacts/updateOrganisationContactService';
import OrganisationContactService from '../../services/contacts/organisationContactService';
import { mapContact } from '../../helpers/contacts/mapContact';

const EditContact = ({
  open,
  dispatchUpdateOrganisationContactPut,
  updateOrganisationContactFetch,
  dispatchOrganisationContactGet,
  organisationContactFetch,
  organisationId,
  contactId,
  returnRoute,
}) => {
  const { t } = useTranslation();

  const handleSubmit = useCallback(
    body =>
      dispatchUpdateOrganisationContactPut(
        organisationId,
        contactId,
        mapContact(body),
        () => history.push(returnRoute),
        t
      ),
    [organisationId, contactId, returnRoute, dispatchUpdateOrganisationContactPut, t]
  );

  useEffect(() => {
    if (open && organisationId) {
      dispatchOrganisationContactGet(organisationId, contactId, () => history.push(returnRoute), t);
    }
  }, [organisationId, contactId, open, t, returnRoute, dispatchOrganisationContactGet]);

  const defaultData = useMemo(
    () => !organisationContactFetch.pending && organisationContactFetch.value,
    [organisationContactFetch]
  );

  if (!open) return null;

  return (
    <ContactForm
      header={t('editContact')}
      onSubmit={handleSubmit}
      submitProcessing={updateOrganisationContactFetch.pending}
      returnRoute={returnRoute}
      cancelRoute={returnRoute}
      dataLoading={organisationContactFetch.pending}
      data={defaultData}
      editMode
    />
  );
};

EditContact.propTypes = {
  dispatchUpdateOrganisationContactPut: PropTypes.func.isRequired,
  updateOrganisationContactFetch: PropTypes.object.isRequired,
  dispatchOrganisationContactGet: PropTypes.func.isRequired,
  organisationContactFetch: PropTypes.object.isRequired,
  organisationId: PropTypes.string.isRequired,
  contactId: PropTypes.string.isRequired,
  returnRoute: PropTypes.string.isRequired,
  open: PropTypes.bool,
};

EditContact.defaultProps = { open: false };

export default compose(OrganisationContactService, updateOrganisationContactService)(EditContact);
